import { useEffect } from "react";
import { VOICE } from "../config";
import { useStore } from "../store";
import { withSpeaker } from "./speaking";

/**
 * Listens to who speaks in the Activity's voice channel (decision 146) and keeps the list in the
 * store for the pods. Nothing leaves the device. Without the flag, a voice channel or the scope,
 * Discord refuses the subscription and no one glows.
 */
export function useSpeaking(): void {
  const sdk = useStore((s) => s.sdk);
  useEffect(() => {
    const channel = sdk?.channelId ?? null;
    if (!VOICE || sdk === null || channel === null) return;
    const set = useStore.getState().set;
    const start = ({ user_id }: { user_id: string }) =>
      set({ speaking: withSpeaker(useStore.getState().speaking, user_id, true) });
    const stop = ({ user_id }: { user_id: string }) =>
      set({ speaking: withSpeaker(useStore.getState().speaking, user_id, false) });
    const args = { channel_id: channel };
    void sdk.subscribe("SPEAKING_START", start, args).catch(() => undefined);
    void sdk.subscribe("SPEAKING_STOP", stop, args).catch(() => undefined);
    return () => {
      void sdk.unsubscribe("SPEAKING_START", start, args).catch(() => undefined);
      void sdk.unsubscribe("SPEAKING_STOP", stop, args).catch(() => undefined);
      set({ speaking: [] });
    };
  }, [sdk]);
}
